// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"46":"5676c3bf","497":"5676c3bf","932":"5676c3bf","944":"5676c3bf"}[chunkId] + ".chunk.css";
};